module.exports = __webpack_public_path__ + "assets/img/5.1e9c829f.png";